import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=f20b26a6"
import script from "./Events.js?vue&type=script&lang=js&external"
export * from "./Events.js?vue&type=script&lang=js&external"
import style0 from "./Events.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports